import { reactComponentIds, updateReactComponent } from '../react';
import { checkDeviceType, devices } from '../utils/checkDeviceType';

export type HeaderPropsType = {
  showHeroMap: boolean;
};

export const HeaderProps: HeaderPropsType = {
  showHeroMap: false,
};

// Elements
const topNavigation = document.getElementById('top-navigation');
const topLogotype = document.getElementById('top-logotype');
const hero = document.getElementById('hero') as HTMLElement;

const mainContent = document.getElementById('main');
let topNavigationHeight: number | undefined;

export class Header {
  constructor() {
    this.setHero();
    this.setScroll();
  }

  //Set hero functions
  setHero() {
    if (hero) {
      let isMobile = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1;
      let backgroundImageContainer: HTMLElement;

      if (isMobile) {
        backgroundImageContainer = hero.querySelector('.hero-image-mobile') as HTMLElement;
      } else {
        backgroundImageContainer = hero.querySelector('.hero-image') as HTMLElement;
      }

      if (backgroundImageContainer !== null) {
        const imageUrl = backgroundImageContainer.dataset.backgroundImage;
        if (imageUrl) {
          let preloadImage: HTMLImageElement | null = document.createElement('img');
          if (preloadImage) {
            preloadImage.src = imageUrl;
            preloadImage.addEventListener('load', (event) => {
              hero.classList.add('show');
              backgroundImageContainer.style.backgroundImage = `url(${imageUrl})`;
              preloadImage = null;
            });
          }
        } else {
          hero.classList.add('show');
        }
      } else {
        // If there's no image background image or there's a video background. Display the
        // hero right away.

        // Applying a small timeout to defer the adding of the class to a later event loop
        // This ensures the css animation will be started correctly
        setTimeout(() => {
          hero.classList.add('show');
        }, 10)
      }
    } else {
      topNavigation?.classList.add('fixed-small');
      topNavigationHeight = topNavigation?.offsetHeight;
      if (mainContent && topNavigationHeight) {
        mainContent.style.marginTop = `${topNavigationHeight + 20}px`;
      }
    }
  }

  //Handle scroll
  setScroll() {
    const smallLogo = topLogotype?.querySelector('.small-logo');
    const largeLogo = topLogotype?.querySelector('.circle-bg');

    if (window.scrollY < 50) {
      smallLogo?.setAttribute('tabindex', '-1');
      largeLogo?.setAttribute('tabindex', '0');
    }

    if (topNavigation?.classList.contains('fixed-small')) {
      topNavigation?.classList.remove('use-transition');
      topLogotype?.classList.remove('use-transition');
      topLogotype?.classList.remove('small');

      smallLogo?.setAttribute('tabindex', '0');
      largeLogo?.setAttribute('tabindex', '-1');

      return;
    }

    if (window.scrollY > 50) {
      topNavigation?.classList.add('solid-bg');
      topLogotype?.classList.add('small');
      smallLogo?.setAttribute('tabindex', '0');
      largeLogo?.setAttribute('tabindex', '-1');
    }

    if (!topLogotype?.classList.contains('use-transition') && !topNavigation?.classList.contains('use-transition')) {
      setTimeout(() => {
        topNavigation?.classList.add('use-transition');
        topLogotype?.classList.add('use-transition');
      }, 500);
    }

    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  onScroll() {
    const smallLogo = topLogotype?.querySelector('.small-logo');
    const largeLogo = topLogotype?.querySelector('.circle-bg');
    if (window.scrollY > 50) {
      topNavigation?.classList.add('solid-bg');
      topLogotype?.classList.add('small');
      smallLogo?.setAttribute('tabindex', '0');
      largeLogo?.setAttribute('tabindex', '-1');
    } else {
      topNavigation?.classList.remove('solid-bg');
      topLogotype?.classList.remove('small');
      smallLogo?.setAttribute('tabindex', '-1');
      largeLogo?.setAttribute('tabindex', '0');
    }
  }
}
